// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3b_fp","left":"StickyBox_left__ejHSY","right":"StickyBox_right__2fzfp"};